import { createSlice } from '@reduxjs/toolkit'

import {
  InvitationData,
  InvitationState,
  InvitationStates,
} from 'common/userRoles/userRolesInterfaces'

import { acceptInvitation, getInvitationData as fetchInvitationData } from './thunks'

export const initialState: InvitationState = {
  invitationData: null,
}

export const invitationSlice = createSlice({
  name: 'invitation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchInvitationData.fulfilled, (state, action) => {
        state.invitationData = action.payload.data ?? null
      })
      .addCase(acceptInvitation.fulfilled, (state, action) => {
        const { optin_payload, optin_required } = action.payload

        if (!optin_required) {
          return
        }

        state.invitationData = {
          ...(state.invitationData ?? { state: InvitationStates.ACCEPTED }),
          optin_payload,
          state: InvitationStates.ACCEPTED,
        }
      })
  },
})

export const getInvitationData = (state: RootState): InvitationData | null =>
  state.invitation.invitationData

export default invitationSlice.reducer
